import { inject, Injectable } from '@angular/core';
import { RaToastService } from '@shared/components';
import { catchError, map, Observable } from 'rxjs';
import { UtilService } from 'src/app/shared/utils/utils.service';
import { DocumentPdfApi } from '../../APIs/documents/document-pdf.api';
import { DomainTranslateService } from '../../utils/domain-translate.service';

@Injectable({
    providedIn: 'root',
})
export class DocumentPdfController {
    // * [API]
    private _api = inject(DocumentPdfApi);

    // * [Injects]
    private _utilService = inject(UtilService);
    private _raToastService = inject(RaToastService);
    private _i18n = inject(DomainTranslateService);

    /**
     * Solicita a criação do PDF do documento
     * @param id ID of document
     * @returns Observable of void
     */
    public request(id: string): Observable<void> {
        // O toast de "Gerando PDF..." (com barra de progresso) é responsabilidade do
        // DocumentPdfGenerationService; aqui é só o request à API + tratamento de erro.
        return this._api.request(id).pipe(
            map(response => response.body),
            catchError(error =>
                this._utilService.handleError(
                    error,
                    this._i18n.instant('domain.document.errors.createPdf')
                )
            )
        );
    }

    /**
     * Cobra o download feito pela prévia (impressão local, sem Cloud Run).
     *
     * O erro sobe para quem chamou decidir: sem saldo a API responde 402 e a impressão
     * NÃO pode acontecer, então o toast padrão de erro já basta como aviso.
     * @param id ID of document
     */
    public chargePreviewDownload(id: string): Observable<void> {
        return this._api.chargePreviewDownload(id).pipe(
            map(response => response.body),
            catchError(error =>
                this._utilService.handleError(
                    error,
                    this._i18n.instant('domain.document.errors.createPdf')
                )
            )
        );
    }

    /**
     * Cancela a geração do PDF do documento
     * @param id ID of document
     * @returns Observable of void
     */
    public cancel(id: string): Observable<void> {
        return this._api.cancel(id).pipe(
            map(response => {
                // Mensagem de sucesso
                this._raToastService.success({
                    title: this._i18n.instant('domain.document.pdf.cancelledTitle'),
                    message: this._i18n.instant('domain.document.pdf.cancelledMessage'),
                });

                return response.body;
            }),
            catchError(error =>
                this._utilService.handleError(
                    error,
                    this._i18n.instant('domain.document.errors.cancelPdf')
                )
            )
        );
    }
}
